import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {RiskfactorClasses} from "../../../model";
import {RegistriesService} from "../../../service";

@Injectable()
export class RiskfactorClassResolver implements Resolve<RiskfactorClasses> {
  constructor(private regSrv: RegistriesService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<RiskfactorClasses> {
    const id = route.params.id;
    return this.regSrv.getRiskfactorClassById(id);
  }
}
